import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { FormattedMessage, useIntl } from 'react-intl';
import useDetailsContext from '../context';
import $ from '~/helpers/$';
function EnglishButtonGroup({ title }) {
    return (React.createElement("div", { className: "button-group" },
        React.createElement("a", { href: `/errata/form?book=${encodeURIComponent(title)}`, className: "btn secondary medium" },
            React.createElement(FormattedMessage, { id: "errata.suggest", defaultMessage: "Suggest a correction" })),
        React.createElement("a", { href: `/errata/?book=${encodeURIComponent(title)}`, className: "btn default medium" },
            React.createElement(FormattedMessage, { id: "errata.list", defaultMessage: "Errata list" }))));
}
function ButtonGroup({ title }) {
    const PolishButtonGroup = () => (React.createElement("div", { className: "button-group" },
        React.createElement("a", { href: "https://openstax.pl/pl/errata", className: "btn secondary medium" }, "Zg\u0142o\u015B poprawk\u0119")));
    return $.isPolish(title) ? (React.createElement(PolishButtonGroup, null)) : (React.createElement(EnglishButtonGroup, { title: title }));
}
export function ErrataContents() {
    const { title, errataContent: blurb, bookState } = useDetailsContext();
    return (React.createElement(React.Fragment, null,
        React.createElement(RawHTML, { Tag: "p", html: blurb }),
        bookState !== 'deprecated' && React.createElement(ButtonGroup, { title: title })));
}
export default function ErrataSection() {
    const intl = useIntl();
    const { bookState } = useDetailsContext();
    if (!['live', 'new_edition_available', 'deprecated'].includes(bookState)) {
        return null;
    }
    if (intl.locale === 'es') {
        return null;
    }
    return (React.createElement("div", { className: "loc-errata" },
        React.createElement("h3", null,
            React.createElement(FormattedMessage, { id: "errata.header", defaultMessage: "Errata" })),
        React.createElement(ErrataContents, null)));
}
